module.exports = __webpack_public_path__ + "img/bell.9daed24c.svg";